import React, { useCallback } from "react";
import styles from "./index.module.scss";
import iPrice from "@/modules/tm/assets/detail/price.png";
import { TMDetailCtx } from "@/pages/tm-detail/[code]";
import { useRouter } from "next/router";
import AppRouter from "@/common/app/router";

export interface ITMDetailPriceAreaProps {
  // 售价，元
  price: number;
  // 定金，元
  deposit: number;
  // 服务费比例，0~1
  serviceRatio: number;
}

const TMDetailPriceArea: React.FC<ITMDetailPriceAreaProps> = (props) => {
  const router = useRouter();

  const getPrice = useCallback((value: number) => {
    if (value >= 10000) return (value / 10000).toFixed(2);
    else return value.toFixed(0);
  }, []);

  const onTapLogin = useCallback(() => {
    router.push(AppRouter.User.login({ redirect: window.location.href }));
  }, [router]);

  return (
    <div className={`${styles.container} flex-col flex-main-axis-between`}>
      <div className="flex-row flex-cross-axis-center">
        <img className={styles.priceIcon} src={iPrice} alt="" />
        <div className={styles.title}>出售价格</div>
      </div>
      <div className="flex-row flex-cross-axis-center">
        <TMDetailCtx.Consumer>
          {(value) =>
            value.hasLogin ? (
              <div className={styles.price}>
                ￥{getPrice(props.price)}
                <span>{props.price >= 10000 ? "万" : "元"}</span>
              </div>
            ) : (
              <div className={styles.loginNotice} onClick={onTapLogin}>
                登录获取价格
              </div>
            )
          }
        </TMDetailCtx.Consumer>
        <div className={styles.line} />
        <div className={styles.title} style={{ marginRight: 10 }}>
          预付定金
        </div>
        <div className={styles.value}>
          ￥{getPrice(props.deposit)}
          {props.deposit >= 10000 ? <span>万</span> : null}
        </div>
        <div className={styles.line} />
        <div className={styles.title} style={{ marginRight: 10 }}>
          服务费
        </div>
        <div className={styles.value}>{`${props.serviceRatio * 100}%`}</div>
      </div>
    </div>
  );
};

export default TMDetailPriceArea;
